import { UserIdentityFlowAction, UserIdentityStatusDto } from "@/services/UserIdentitiesService";

export interface RequestAccessPayload
{
    idDocument: string;
    /** Solo cuenta en la cesión automática: el interviniente llega como principal y se borra el principal vacío. */
    promoteToMain: boolean;
}

/**
 * Cuerpo de POST userIdentities/RequestAccess/{id}. La cesión automática no la aprueba nadie, así que el backend exige
 * el DNI del interviniente (auditoría de seguridad G1-22): se envía el que se analizó con analyzeStatus (o el escrito
 * en el formulario si el flujo salió del guardado), junto con la decisión del usuario de hacerlo su principal. En el
 * resto de acciones (préstamo y cesión con aprobación) no se envía nada.
 */
export const buildRequestAccessPayload = (identityStatus: UserIdentityStatusDto | null | undefined, promoteToMain: boolean = false): RequestAccessPayload | undefined =>
{
    if(identityStatus?.action !== UserIdentityFlowAction.AutomaticOwnershipTransfer)
    {
        return undefined;
    }

    const idDocument = identityStatus.dni?.trim();
    return idDocument ? { idDocument, promoteToMain: promoteToMain === true } : undefined;
};
